import { API_ERROR_MSG } from '@share/constant';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { toast } from 'react-toastify';
import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { user } from '@state/user';
import AccountGeneral from '@com/profile/AccountGeneral';
import AccountKYC from '@com/profile/AccountKYC';
import Footer from '@com/footer/Footer';
import Header from '@com/header/Header';
import TopSection from '@com/TopSection';

function EditProfile(): JSX.Element {
  const { t, ready } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { isLogin } = user.useContainer();

  const PARAM_NAME = 'type';
  const tabIndexMap: Record<string, number> = {
    general: 0,
    auth: 1,
  };

  const selectedIndex = useMemo(() => {
    return tabIndexMap[String(searchParams.get(PARAM_NAME))] || 0;
  }, [location.search]);

  /* Styling */
  useEffect(() => {
    // must be equal false cause when refreshing isLogin == null
    if (isLogin === false && ready) {
      // Prevent showing 401 error message
      toast.info(t('alertMessage.login'), { toastId: API_ERROR_MSG });
      navigate(`/`);
    }
  }, [isLogin, ready]);

  return (
    <>
      <Header />
      <TopSection sectionName={t('editProfilePage.account')} />
      <div className="tf-create-item tf-section content-container">
        <div className="flat-tabs themesflat-tabs w-100 p-4">
          <Tabs
            selectedIndex={selectedIndex}
            onSelect={(index) => {
              navigate(
                `${location.pathname}?${PARAM_NAME}=${
                  Object.keys(tabIndexMap)[index]
                }`
              );
            }}
          >
            <TabList className="mb-5 d-flex justify-content-center">
              <Tab data-test="general-tab">{t('editProfilePage.general')}</Tab>
              <Tab data-test="auth-tab">{t('editProfilePage.KYC')}</Tab>
            </TabList>

            <TabPanel>
              <AccountGeneral />
            </TabPanel>

            <TabPanel>
              <AccountKYC />
            </TabPanel>
          </Tabs>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default EditProfile;
